<template>
  <div class="load" element-loading-text="正在登录..." v-loading="loading"></div>
</template>

<script>
  import { mapMutations, mapState } from "vuex";
  import axios from "@/axios";
  const base = process.env.VUE_APP_API_ROOT;
  export default {
    data() {
      return {
        loading: true
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      ...mapMutations(["changeLogin"]),
      getData() {
        localStorage.setItem("authorization", this.$route.query.token);
        let token = this.$route.query.token;
        axios({
          method: "post", //请求方式
          url: `${base}/biz-admin/productDemonstrate/singleSignOn/taxfirm`,
          headers: {
            'Authorization': token
          }
        }).then(res => {
          // console.log(res)
          let data = res.data.data;
          localStorage.setItem("user", JSON.stringify(data.user));
          localStorage.setItem("token", JSON.stringify(data.token));
          this.changeLogin({ authorization: data.token });
          this.$router.push({ path: "/" });
        })
      }
    }
  }
</script>

<style scoped>
  .load {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
</style>